import { Fragment } from "react";

export const B = ({ dark = false }) => (
  <span className={dark ? "font-bold text-secondary" : "font-bold text-[#8a6d2f]"}>One More Shift</span>
);

export const withBrand = (text, dark = false) =>
  text.split("One More Shift").map((part, i, arr) => (
    <Fragment key={i}>
      {part}
      {i < arr.length - 1 && <B dark={dark} />}
    </Fragment>
  ));
